
<div id="pagConfig" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">person_add</mat-icon> -->
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{nombreEmpresa}}: {{'GESTORSTATUS.TITULO' | translate}}
            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center center">

            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center center" [@animateStagger]="{value:'50'}">
              <ng-container *ngFor="let funcion of funciones">
                <div class="course" *ngIf="funcion.numero > 0" fxFlex="100" fxFlex.gt-xs="50"
                  fxFlex.gt-sm="33"  [ngClass]="funcion.category" [@animate]="{value:'*',params:{y:'100%'}}">

                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex>
                        {{'GESTORSTATUS.PRODUCTOS.'+funcion.id | translate}}
                      </div>
                    </div>

                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1">{{'GESTORSTATUS.PRODUCTOS.NUMPROD' | translate}}{{funcion.numero}}</div>
                      <!-- <mat-icon class="length-icon s-120">{{funcion.icon}}</mat-icon> -->
                      <!-- <img src="assets/images/logos/{{funcion.imagen}}.png" alt=""> -->
                    </div>
                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button color="accent" (click)="accesoProducto(funcion.slug)">
                        {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                      </button>
                      <!-- <button mat-button color="accent" (click)="Tableau()">
                        {{'RESULTADOS.SECCIONES.'+funcion.id+'.BOTON' | translate}}
                      </button> -->
                    </div>

                  </div>

                </div>
              </ng-container>

              <div class="no-courses" *ngIf="funciones.length === 0">
                  <h1>{{'GESTORSTATUS.PRODUCTOS.NOPRODUCTOS' | translate}}</h1>
              </div>

            </div>

        </div>

    </div>
    <!-- / CONTENT -->

</div>
